/*
 * @Author: ningbo.kang
 * @Date: 2019-10-18 09:54:54
 * @LastEditors: zerui.yao
 * @LastEditTime: 2024-03-29 17:11:31
 * @FilePath: /fed-authority/src/core/use.js
 * @Description: 描述
 */
// base library
import 'ant-design-vue/dist/antd.less';
import '@/assets/css/index.less';

import UIComp from '@/components';
import Loading from '@/components/Loading/index.vue';
import loadSetting from './loadSetting';
import pluginError from './error';
import allow from './directives/allow';
import iconfontJs from './iconfont.js';

// svg 图标
import '@/assets/svg-icons';

export default {
  async install(Vue) {
    // https://loading.io/spinner/
    // 增强spin，默认设置4中效果
    window.antd.Spin.setDefaultIndicator(loadSetting);
    // 注册menu菜单组件
    // TODO: 地址存储在全局配置中维护或者env变量
    const IconMenu = window.antd.Icon.createFromIconfontCN({
      /* 系统管理-菜单管理-左侧导航栏图标库 */
      scriptUrl: '//at.alicdn.com/t/font_2317187_heqzeyriww.js',
    });
    Vue.component('IconMenu', IconMenu);
    // 项目内图标库
    const IconFont = window.antd.Icon.createFromIconfontCN({
      scriptUrl: iconfontJs, // 在 iconfont.cn 上生成
    });
    Vue.component('IconFont', IconFont);

    // 表格默认大小设置到middle
    window.antd.Table.props.size.default = 'middle';
    Vue.use(UIComp);

    // 插件
    // 错误捕获
    if (process.env.NODE_ENV !== 'production') {
      Vue.use(pluginError);
    }

    // 全局loading
    const AppLoading = Vue.extend(Loading);
    const loading = new AppLoading().$mount(document.createElement('div'));
    document.body.appendChild(loading.$el);
    Vue.prototype.$loading = loading;

    // 注册指令
    allow(Vue);
    // 输入框禁止输入首尾空格
    // 使用@change="$trim"
    Vue.prototype.$trim = ($event) => {
      $event.target.value = $event.target.value.replace(/^\s+|\s+$/g, '');
    };
  },
};
